<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Consulta de médicos</h3>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-inline">
              <label for="pagos">Pago de suscripción</label>
              <label for="todosPagos">
                <input
                  type="radio"
                  name="tipoPago"
                  id="todosPagos"
                  v-model="form.tipo_pago"
                  value="T"
                />
                <span>Todos</span>
              </label>
              <label for="pagados">
                <input
                  type="radio"
                  name="tipoPago"
                  id="pagados"
                  v-model="form.tipo_pago"
                  value="S"
                />
                <span>Pagados</span>
              </label>
              <label for="sinPagar">
                <input
                  type="radio"
                  name="tipoPago"
                  id="sinPagar"
                  v-model="form.tipo_pago"
                  value="N"
                />
                <span>Sin pagar</span>
              </label>
              <label for="aprobacion">
                <input
                  type="radio"
                  name="tipoPago"
                  id="aprobacion"
                  v-model="form.tipo_pago"
                  value="A"
                />
                <span>Pendientes de aprobación</span>
              </label>
            </div>
          </div>
        </div>
        <k-table
          @aprobar="aprobar"
          :filterStatus="form.tipo_pago === 'T'"
          :params="form"
          ref="doctores"
          :path="path"
          :createButton="permiteCrear"
          :editButton="permiteEditar"
          :deleteButton="permiteEliminar"
          @editar="editar"
          @crear="crear"
          :buttons="
            permiteEditar
              ? [
                  {
                    class: 'btn-success btn--text',
                    event: 'aprobar',
                    icon: 'fa-check',
                  },
                ]
              : []
          "
          @eliminar="eliminar"
          exportable
          :columns="[
            {
              display: 'Foto',
              value: 'url_imagen',
              image: true,
            },
            {
              display: 'Nombre',
              value: 'nombre',
            },
            {
              display: 'Especialidades',
              value: 'descripcion_especialidades',
            },
            {
              display: 'Otras especialidades',
              value: 'otras_especialidades',
            },
            {
              display: 'Cédula',
              value: 'cedula',
            },
            {
              display: 'Ciudad',
              value: 'ciudad.descripcion',
            },
            {
              display: 'Dirección',
              value: 'direccion',
            },
            {
              display: 'Teléfonos',
              value: 'telefonos',
            },
            {
              display: 'Correo electrónico',
              value: 'correo',
            },
            {
              display: 'Sexo',
              value: 'descripcion_sexo',
            },
            {
              display: 'Aprobado',
              value: 'aprobado',
            },
            {
              display: 'Creación',
              value: 'created_at',
            },
            {
              display: 'Modificación',
              value: 'updated_at',
            },
            {
              display: 'Creador',
              value: 'nombre_creador',
            },
            {
              display: 'Modificador',
              value: 'nombre_modificador',
            },
          ]"
        ></k-table>
      </div>
    </div>
    <modal
      :clickToClose="false"
      focus-trap
      resizable
      reset
      adaptive
      name="doctor"
      scrollable
      width="70%"
      height="auto"
    >
      <k-doctor
        :provincias="provincias"
        :especialidades="especialidades"
        v-model="selectedDoctor"
        @saved="saved"
        @cancelar="cancelar"
      ></k-doctor>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    provincias: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    especialidades: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    permiteCrear: {
      type: Boolean,
      required: false,
      default: true,
    },
    permiteEditar: {
      type: Boolean,
      required: false,
      default: true,
    },
    permiteEliminar: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data: function () {
    return {
      selectedDoctor: null,
      path: url + "/doctores",
      nuevoDoctor: false,
      selectedIndex: -1,
      form: {
        tipo_pago: "A",
      },
    };
  },
  methods: {
    aprobar: function (row) {
      swal({
        title: "¿Desea aprobar el médico seleccionado?",
        text: "Se requiere de confirmación del usuario",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          axios
            .post(url + "/doctores/" + row.id + "/aprobar", {
              _method: "PUT",
            })
            .then(() => {
              swal(
                "El médico fue aprobado exitósamente.",
                "Realizado",
                "success"
              );
              this.$refs.doctores.loadRows();
            })
            .catch(() => {
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    crear: function () {
      this.nuevoDoctor = true;
      this.selectedDoctor = {
        codigo_senescyt: "",
        contrato: "",
        archivo_senescyt: "",
        anexo_1: "",
        anexo_2: "",
        imagen: "",
        nombre: "",
        fecha_nacimiento: "",
        id: "",
        cedula: "",
        direccion: "",
        telefonos: "",
        correo: "",
        sexo: "M",
        biografia: "",
        estado: "N",
        especialidades: [],
        _method: undefined,
        fotos: [],
        clave_acceso: "",
        ciudad_id: "",
        provincia_id: "",
        latitud: "",
        longitud: "",
        logo_receta: "",
        foto_sello: "",
        foto_firma: "",
        saldo_pagar: 0,
        tipo_documento: "C",
        path_firma_electronica: "",
        password_firma_electronica: "",
        password_firma_electronica_confirmation: "",
        fecha_caducidad_firma_electronica: "",
        tipo_cuenta: "A",
        numero_cuenta: "",
        nombre_cuenta: "",
        identificacion_cuenta: "",
        banco: "",
        comentario: "",
        tipo_identificacion_cuenta: "C",
        es_odontologo: false,
        es_otras_especialidades: false,
      };
      this.$modal.show("doctor");
    },
    editar: function (row) {
      this.nuevoDoctor = false;
      this.selectedDoctor = {  
        _method: "PUT",      
        id: row.id, //
        nombre: row.nombre, //
        fecha_nacimiento: //
          row.fecha_nacimiento !== null ? new Date(row.fecha_nacimiento) : "",
        cedula: row.cedula, //
        direccion: row.direccion, //
        telefonos: row.telefonos, //
        correo: row.correo, //
        sexo: row.sexo,//
        biografia: row.biografia, //
        estado: row.estado, //
        imagen: row.url_imagen, //
        especialidades: [], //
        
        fotos: [],//
        ciudad_id: row.ciudad_id,//
        latitud: row.latitud,//
        longitud: row.longitud,//
        provincia_id: row.ciudad !== null ? row.ciudad.id_provincia : "",//        
        saldo_pagar: row.saldo_pagar,//
        path_firma_electronica: row.url_firma_electronica,//
        password_firma_electronica: row.password_firma_electronica,//
        password_firma_electronica_confirmation: row.password_firma_electronica,//
        fecha_caducidad_firma_electronica: //
          row.fecha_caducidad_firma_electronica !== null ? new Date(row.fecha_caducidad_firma_electronica) : "",
        codigo_senescyt: row.codigo_senescyt,
        logo_receta: row.url_receta,
        foto_sello: row.url_sello,
        foto_firma: row.url_firma,
        contrato: row.url_contrato,
        archivo_senescyt: row.url_archivo_senescyt,
        anexo_1: row.url_anexo_1,
        anexo_2: row.url_anexo_2,
        tipo_documento: row.tipo_documento,
        tipo_cuenta: row.tipo_cuenta,
        numero_cuenta: row.numero_cuenta,
        nombre_cuenta: row.nombre_cuenta,
        identificacion_cuenta: row.identificacion_cuenta,
        banco: row.banco,
        tipo_identificacion_cuenta: row.tipo_identificacion_cuenta,
        comentario: row.comentario,
        es_odontologo: row.es_odontologo === "S",
        es_otras_especialidades: row.es_otras_especialidades === "S",
      };
      for (let i = 0; i < row.especialidades.length; i++)
        this.selectedDoctor.especialidades.push(row.especialidades[i].id);
      for (let i = 0; i < row.fotos.length; i++)
        this.selectedDoctor.fotos.push({
          imagen: row.fotos[i].url_imagen,
        });
      this.selectedIndex = this.$refs.doctores.rows.indexOf(row);
      this.$modal.show("doctor");
    },
    eliminar: function (row) {
      let that = this;
      swal({
        title:
          "¿Está seguro de realizar la " +
          (row.estado === "A" ? "inactivación" : "activación") +
          " del médico seleccionado?",
        text: "Se requiere de confirmación del usuario",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          axios
            .post(url + "/doctores/" + row.id, {
              _method: "DELETE",
            })
            .then(function () {
              swal(
                "Se ha cambiado el estado del registro seleccionado.",
                "Realizado",
                "success"
              );
              that.$refs.doctores.loadRows();
            })
            .catch(function () {
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    saved: function (row) {
      if (this.nuevoDoctor) {
        this.$refs.doctores.rows.unshift(row);
        this.nuevoDoctor = false;
      } else this.$refs.doctores.rows.splice(this.selectedIndex, 1, row);
      this.$modal.hide("doctor");
    },
    cancelar: function () {
      this.nuevoDoctor = false;
      this.selectedIndex = -1;
      this.$modal.hide("doctor");
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/doctores/ConsultaDoctores.vue